import { render } from "./One5.vue?vue&type=template&id=325a716e&scoped=true&lang=pug"
import script from "./One5.vue?vue&type=script&lang=js"
export * from "./One5.vue?vue&type=script&lang=js"

import "./One5.vue?vue&type=style&index=0&id=325a716e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\freemath\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-325a716e"]])

export default __exports__